import React from 'react';
import { useField } from 'react-final-form';

import { useCurrentScenarioName } from '@wp-block-builder/editor/hooks';

export default function CurrentScenarioName() {
  const [currentScenarioName] = useCurrentScenarioName();
  if (!currentScenarioName) {
    return <>Default</>;
  }
  return <ScenarioName name={currentScenarioName} />;
}

function ScenarioName({ name }: { name: string }) {
  const { input } = useField<string>(`${name}.name`);
  return <>{input.value}</>;
}
